import { Button, Col, Container, Image, Nav, Navbar, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { IoIosClose, IoIosMenu } from "react-icons/io";
import React, { useContext, useEffect, useState } from "react";

import BarraBusqueda from "./BarraBusqueda/BarraBusqueda";
import DatosUsuario from "./DatosUsuario/DatosUsuario";
import UserContext from "@context/User/UserContext";
import { useHistory } from "react-router-dom";
import useWindowResize from "customHooks/useWindowResize";
import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import { getTemas } from "@helpers/httpRequests/httpRequestApariencia/httpRequestApariencia";
import RegistrarUsuarioLecturaAdicional from "./Modales/RegistrarUsuarioLecturaAdicional";
import { ModalSweetAlert } from "../Alertas/Alertas";
import { validarHayConvenio } from "@helpers/httpRequests/httpRequestConvenios/httpRequestConvenios";
import { useTranslation } from "react-i18next";

const NavBar = ({language, className, toggleSidebar, isSidebarActive, setIsSidebarActive, handleChangeComponent, temaSeleccionado, setTemaSeleccionado }) => {
	const {t} = useTranslation();

	const history = useHistory();

	const {
		size: { width },
	} = useWindowResize();

	const { contextValue: userContextValue, setContextValue: setUserContextValue } = useContext(UserContext);

	const { usuarioLogeado } = userContextValue;

	const { nombreCompleto, apellidos, servicioActivo, rol, idLicencia, idCodigoRegion, idPerfil, idCredencial, folioContrato, nombreLicencia} = usuarioLogeado;

	const [menuColapse, setMenuColapse] = useState(false);

	const [logoSeleccionado, setLogoSeleccionado] = useState("click.png");

	const [nombreLogoSeleccionado, setNombreLogoSeleccionado] = useState("Sin tema")

	const [datosUsuario, setDatosUsuario] = useState({
		nombreUsuario: `${nombreCompleto} ${apellidos}`,
		permiso: false,
	});

	const [usuarioConConvenio, setUsuarioConConvenio]= useState(false);

	const handleChangeSideBar = (e) => {
		setIsSidebarActive(!isSidebarActive);
	};

	const handleProfile = (x) => {
		const { miPerfil } = multiViewComponentsPaths;

		try {
			handleChangeComponent(miPerfil);
		} catch (e) {
			console.log("handleProfile");

			console.log(e);
		}
	};

	const handleProfileSelection = () => {
		sessionStorage.removeItem("lastRoute");

		history.push("/perfiles");
	};

	const handleBotonColapse = () => {
		try {
			if (isSidebarActive === false) {
				setMenuColapse(!menuColapse); //desaparece el boton

				handleChangeSideBar(); //muestra el menu activo largo
			} else {
				handleChangeSideBar(); //muestra el menu corto

				setMenuColapse(false); //mantener el boton invisible
			}
		} catch (e) {
			console.log(e);
		}
	};

	const handleRegisterSecondaryUser = async () => {
		try {
			handleChangeComponent("registroSegundoUsuario");
			// setState({ direccion: 'segundoPerfil' });
		} catch (e) {
			console.log(e);
		}
	};

	const handleRegistrarUsuarioLecturaAdicional = () =>{
		 ModalSweetAlert({
			  html: (
				<RegistrarUsuarioLecturaAdicional idPerfil={idPerfil} idRegion={idCodigoRegion} idLicencia={idLicencia} rol={rol} idCredencial={idCredencial} setContextValue={setUserContextValue} contextValue={userContextValue} />
			  ),
			  showConfirmButton: false,
			  showCloseButton: true,
			});
	}

	const handleLogout = () => {
		try {
			localStorage.removeItem("dataUserLogged");

			localStorage.removeItem("lastRoute");

			localStorage.removeItem("token");

			localStorage.removeItem('i18nextLng');

			localStorage.clear();

			sessionStorage.clear();

			// userContext.setStateContext({});

			history.replace("/");
		} catch (e) {
			console.log(e);
		}
	};

	const [temas, setTemas] = useState(null);

	useEffect(() => {
		try {
			// handlePermition();
			const obtenerTemasApariencia = async () => {
				try {
					const { data } = await getTemas();
					data.map((tema) => {
						if (tema.estatus) {
							setNombreLogoSeleccionado(tema.nombreTema);
							setLogoSeleccionado(tema.aparienciaLogo);
						}
					});
					setTemas(data);
				} catch (error) {
					console.log(error);
				}
			};

			obtenerTemasApariencia();

			const validarConvenio = async() => {
				if(rol === "asesor_lectura"){
					setUsuarioConConvenio(true);
					return;
				}
				try {
					const results= await validarHayConvenio(folioContrato);

					setUsuarioConConvenio(true);
				} catch (error) {
					console.log("Error al validar el convenio");
				}
			}

			if (rol === 'asesor_lectura' || rol === 'lectura_veloz') {
				validarConvenio();
			}
		} catch (e) {
			console.log(e);
		}
	}, []);

	useEffect(() => {
		try {
			// handlePermition();
			const obtenerTemasApariencia = async () => {
				try {
					const { data } = await getTemas();
					data.map((tema) => {
						if (tema.estatus) {
							setNombreLogoSeleccionado(tema.nombreTema);
							setLogoSeleccionado(tema.aparienciaLogo);
						}
					});
					setTemas(data);

					setTemaSeleccionado(false);
				} catch (error) {
					console.log(error);
				}
			};

			obtenerTemasApariencia();
		} catch (e) {
			console.log(e);
		}
	}, [temaSeleccionado]);

	const handleSidebarCollapse = (e) => {
		// console.log('first')

		if (width > 768) {
			handleBotonColapse();
		} else {
			toggleSidebar();
		}
	};

	// const BotonMenuSidebar = () => {
	// 	return (
	// 		<OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-top`}>Desplegar menú</Tooltip>}>
	// 			<Button variant="outline-warning" onClick={handleSidebarCollapse} className="navbar-buttons">
	// 				{isSidebarActive ? <IoIosClose /> : <IoIosMenu />}
	// 			</Button>
	// 		</OverlayTrigger>
	// 	);
	
	// };

	return (
		<>
			{/* Bootstrap 5 */}
			<Navbar expand="lg" data-bs-theme="dark" bg="dark" className="bg-dark-custom d-flex justify-content-between">
				<div className="d-flex align-items-center">
					<Navbar.Brand href="#home">
						<div className="m-1">
							{(rol === "lectura_veloz" || rol === "asesor_lectura") ? (
								<>
								{(usuarioConConvenio || nombreLicencia === 'Lectura Inteligente - UVEG') && (
									<a href="https://uveg.edu.mx/index.php/es/" alt="UVEG" target="_blank" >
										<img
											className="pointer"
											src={require(`@assets/images/uvegActualizado.png`)}
											alt="Logo Smart Click"
											style={{ width: `${width > 992 ? "6vw" : "12vw"}`, margin: "1em" }}
										/>
									</a>
								)}
								<img
									className="pointer"
									onClick={() => handleChangeComponent((rol !== 'lectura_veloz' && rol !== 'asesor_lectura') ? "home" : "homeLecturaVeloz")}
									src={require(`@assets/images/logo-gc-horizontal.png`)}
									alt="Logo Smart Click"
									style={{ width: `${width > 992 ? "10vw" : "20vw"}`, margin: "1em" }}
								/>
								</>
							): (
								<img
									className="pointer"
									onClick={() => handleChangeComponent(rol !== 'lectura_veloz' ? rol !== 'invitado'? "home" : "homeInvitado" : "homeLecturaVeloz")}
									src={nombreLogoSeleccionado !== "Personalizado" ? require(`@assets/images/${logoSeleccionado}`) : logoSeleccionado}
									alt="Logo Global Click"
									style={{ width: `${width > 992 ? "10vw" : "20vw"}` }}
								/>
							)}
						</div>
					</Navbar.Brand>

					<OverlayTrigger placement="right" overlay={<Tooltip id={`tooltip-top`}>{t('Display menu')}</Tooltip>}>
						<Button variant="outline-warning" onClick={handleSidebarCollapse} className="navbar-buttons">
							{isSidebarActive ? <IoIosClose /> : <IoIosMenu />}
						</Button>
					</OverlayTrigger>
				</div>

				{
					servicioActivo ? 
					(usuarioLogeado.rol !== typesTiposUsuario.invitado && usuarioLogeado.rol !== typesTiposUsuario.lecturaVeloz && usuarioLogeado.rol !== typesTiposUsuario.asesorLectura && usuarioLogeado.rol !== typesTiposUsuario.cortesia  && usuarioLogeado.rol !== typesTiposUsuario.gestion) && (
						<span className={`search-bar ms-3 ${width < 1024 ? "d-none" : ""}`}>
							<BarraBusqueda handleChangeComponent={handleChangeComponent} parent="desktop-navbar" width={width} handleSidebarCollapse={handleSidebarCollapse} isSidebarActive={isSidebarActive} />
						</span>
					)
					: null
				}

				<DatosUsuario
				language={language}
				handleRegistrarUsuarioLecturaAdicional={handleRegistrarUsuarioLecturaAdicional}
					nombreUsuario={datosUsuario.nombreUsuario}
					handleChangeComponent={handleChangeComponent}
					handleProfile={handleProfile}
					handleProfileSelection={handleProfileSelection}
					handleRegisterSecondaryUser={handleRegisterSecondaryUser}
					handleLogout={handleLogout}
					width={width}
				/>
			</Navbar>

			{/* Bootstrap 4.6 */}

			{/* <header role="banner" className={`navbar navbar-expand navbar-light bg-dark-custom ${className}`}>
				<div className="m-1">
					<img
						className="pointer"
						onClick={() => handleChangeComponent("home")}
						src={require(`@assets/images/${logoSeleccionado}`)}
						alt="Logo Global Click"
						style={{ width: `${width > 992 ? "10vw" : "20vw"}` }}
					/>
				</div>

				<OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-top`}>Desplegar menú</Tooltip>}>
					<Button variant="outline-warning" onClick={handleSidebarCollapse} className="navbar-buttons">
						{isSidebarActive ? <IoIosClose /> : <IoIosMenu />}
					</Button>
				</OverlayTrigger>

				{usuarioLogeado.rol !== typesTiposUsuario.invitado && usuarioLogeado.rol !== typesTiposUsuario.lecturaVeloz && (
					<span className={`search-bar ms-3 ${width < 768 ? "d-none" : ""}`}>
						<BarraBusqueda handleChangeComponent={handleChangeComponent} parent="desktop-navbar" width={width} />
					</span>
				)}

				<DatosUsuario
					nombreUsuario={datosUsuario.nombreUsuario}
					handleChangeComponent={handleChangeComponent}
					handleProfile={handleProfile}
					handleProfileSelection={handleProfileSelection}
					handleRegisterSecondaryUser={handleRegisterSecondaryUser}
					handleLogout={handleLogout}
					width={width}
				/>
			</header> */}
		</>
	);
};

export default NavBar;
